<template>
  <div class="relative">
    <button v-if="filteredActions.length"
            @click="dropdownOpen = !dropdownOpen"
            class="text-white bg-indigo-700 w-auto hover:bg-indigo-800 focus:ring-2 focus:outline-none focus:ring-indigo-300
        font-medium rounded text-md px-4 py-1 text-center inline-flex items-center"
            type="button">
      {{ this.$lang.app.ACTION }}
      <ChevronDownIcon class="ml-2 w-4 h-4"/>
    </button>

    <div v-show="dropdownOpen"
         @click="dropdownOpen = false"
         class="fixed inset-0 z-10 w-full h-full"></div>

    <transition
        enter-active-class="transition duration-150 ease-out transform"
        enter-from-class="scale-95 opacity-0"
        enter-to-class="scale-100 opacity-100"
        leave-active-class="transition duration-150 ease-in transform"
        leave-from-class="scale-100 opacity-100"
        leave-to-class="scale-95 opacity-0">
      <div v-show="dropdownOpen"
           class="absolute right-0 z-20 w-52 py-2 mt-2 bg-white rounded-md shadow-xl">
        <ul class="w-full">
          <li v-for="(action, key) in filteredActions" :key="key"
              class="block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white cursor-pointer"
              @click="handleAction(action.constName)">
            {{ action.name }}
          </li>
        </ul>
      </div>
    </transition>

    <AcceptModal :application="application"
                 :additional="additional"/>

    <ReturnModal/>
  </div>
</template>
<script>
import ReturnModal from "./modals/ReturnModal.vue"
import AcceptModal from "./modals/AcceptModal.vue"

export default {
  components: {
    ReturnModal,
    AcceptModal,
  },
  props: {
    application: Object,
    actions: Array,
    additional: Object
  },
  data() {
    return {
      dropdownOpen: false,
    }
  },
  computed: {
    filteredActions() {
      return this.actions.filter(action => [
        'APPLICATIONS_ACCEPT_ADDITIONAL_AGREEMENT_ACTION',
        'APPLICATIONS_REWORK_ADDITIONAL_AGREEMENT_ACTION',
      ].includes(action.constName))
    }
  },
  methods: {
    handleAction(action) {
      this.dropdownOpen = false
      switch (action) {
        case 'APPLICATIONS_ACCEPT_ADDITIONAL_AGREEMENT_ACTION':
          this.$emitter.emit('openApplicationAdditionalAgreementAcceptModal');
          break;
        case 'APPLICATIONS_REWORK_ADDITIONAL_AGREEMENT_ACTION':
          this.$emitter.emit('openApplicationAdditionalAgreementReturnModal', this.additional)
          break;
      }
    },
  }
}
</script>
